import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ModalDataChangeEmail } from '@app/core/services/modal/modal-interfaces';
import { Modal2Service } from '@app/core/services/modal/modal2.service';
import { WarningService } from '@app/core/services/warning/warning.service';
import { NavParams } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

interface ModalResponse {
    verified: boolean;
}

@Component({
    selector: 'app-user-account-settings-modal2-email',
    templateUrl: './user-account-settings-modal2-email.component.html',
    styleUrls: ['./user-account-settings-modal2-email.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserAccountSettingsModal2EmailComponent {
    header: string = '';
    currentEmail: string = '';
    newEmail: string = '';
    newEmailConfirm: string = '';

    constructor(navParams: NavParams, private modal2Service: Modal2Service, private warningService: WarningService) {
        this.header = navParams.get('header');
        this.currentEmail = navParams.get('email');
    }

    async submit() {
        if (this.newEmail === this.newEmailConfirm) {
            this.modal2Service
                .openUserAccountVerifyEmail({ header: 'Verify your email address', currentEmail: this.newEmail } as ModalDataChangeEmail)
                .then((response: ModalResponse) => {
                    if (response.verified) {
                        this.modal2Service.toast('Successfully Update Email');
                        this.dismiss();
                    } else {
                        this.modal2Service.toast('Please check your email inbox to verify your email changes.');
                    }
                });
        }
    }

    dismiss() {
        this.modal2Service.dismiss();
    }
}
